import { ShowInfoModalProvider } from "./showInfoModal";
import { AuthProvider } from './AuthProvider';
import { LoadProvider } from "./loadProvider";

const MultiProvider = ({ children }) => {
    return <ShowInfoModalProvider>
        <AuthProvider>
            <LoadProvider>
                {children}
            </LoadProvider>
        </AuthProvider>
    </ShowInfoModalProvider>
}

export default MultiProvider;
